const fontSize = {
  large: '18px',
  default: '16px',
  minor: '14px',
  micro: '12px'
} as const

const heading = {
  h1Super: '66px',
  h1: '52px',
  h2: '40px',
  h3: '28px',
  h4: '22px'
} as const

export const typography = {
  fontSize,
  heading
} as const
